import type { CourseType } from 'bundles/enterprise-legacy-learner-home/utils/courseTypeMetadataUtils';

/**
 * This holds general page information
 */
class PageViewController {
  declare courseType: CourseType;

  constructor(courseType: CourseType) {
    this.courseType = courseType;
  }
}

export default PageViewController;
